import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  Tabs,
} from 'antd';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import { userPrivilagesAtom } from '../../../atoms/Atoms';
import MyCommissionsSection from './shared-components/MyCommissionsSection';

function MyCommissions() {
  const { t } = useTranslation();
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const [selectedTab, setSelectedTab] = useState('closer');

  useEffect(() => {
    setSelectedTab('closer');
  }, []);

  return (
    <MainPage includeBack>
      <div className="flex mt-4">
        <H1 text={t('my_commissions')} />
      </div>
      {userPrivilages.hasSetter && userPrivilages.hasCloserPrivilages && (
        <Tabs activeKey={selectedTab} onChange={(obj) => setSelectedTab(obj)}>
          <Tabs.TabPane key="closer" tab={t('closer_commissions')}>
            <MyCommissionsSection type={0} />
          </Tabs.TabPane>
          <Tabs.TabPane key="setter" tab={t('setter_commissions')}>
          <MyCommissionsSection type={1} />
          </Tabs.TabPane>
        </Tabs>
      )}
      {!userPrivilages.hasSetter && userPrivilages.hasCloserPrivilages && (
        <MyCommissionsSection type={0} />
      )}
      {userPrivilages.hasSetter && !userPrivilages.hasCloserPrivilages && (
        <MyCommissionsSection type={1} />
      )}
    </MainPage>
   );
}

export default MyCommissions;
